module.exports = __webpack_public_path__ + "img/challenge-2-fr.7d2e4904.png";